module.exports = __webpack_public_path__ + "img/agree.a80f67a9.png";